import React from 'react';

import {
    FormControl,
    FormHelperText,
    InputLabel,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormRoofSelect = ({
    control,
    disabled,
    fullWidth = true,
    id,
    label = '',
    name,
    onChange,
    options,
    sxFormControl = {},
    variant,
}) => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
            <FormControl
                error={Boolean(error)}
                fullWidth={fullWidth}
                size="small"
                {...sxFormControl}
                variant={variant}
            >
                <InputLabel
                    {...(field?.value && { shrink: Boolean(field.value) })}
                >
                    {label}
                </InputLabel>
                <Select
                    disabled={disabled}
                    displayEmpty={label === ''}
                    id={id}
                    label={label}
                    {...field}
                    onChange={(e) => {
                        field.onChange(e);
                        if (onChange) onChange(e);
                    }}
                    value={field.value !== null ? field.value : ''}
                    sx={{
                        '& .MuiSelect-select': {
                            display: 'flex',
                        },
                        '& .MuiListItemIcon-root': {
                            minWidth: '40px',
                        },
                    }}
                >
                    {options.map(
                        (
                            { image, label, value, disabled: optionDisabled },
                            index,
                        ) => (
                            <MenuItem
                                key={`select-${value}-${label}`}
                                value={value}
                                disabled={optionDisabled}
                            >
                                {index > 0 && image && (
                                    <ListItemIcon>
                                        <img src={image} width={30} />
                                    </ListItemIcon>
                                )}
                                <ListItemText>{label}</ListItemText>
                            </MenuItem>
                        ),
                    )}
                </Select>
                {Boolean(error) && (
                    <FormHelperText>{error?.message}</FormHelperText>
                )}
            </FormControl>
        )}
    />
);

ReactHookFormRoofSelect.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    ignore: PropTypes.array,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    sxFormControl: PropTypes.object,
    variant: PropTypes.string,
};

export default ReactHookFormRoofSelect;
